import { z } from 'zod'

export const SummaryDetails = z.object({
  id: z.string(),
  name: z.string()
})

export type SummaryDetails = z.infer<typeof SummaryDetails>
